import { render, staticRenderFns } from "./df-store-card.vue?vue&type=template&id=1a996200"
import script from "./df-store-card.ts?vue&type=script&lang=js&external"
export * from "./df-store-card.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports